import React, { Component } from "react";
import { Form, Input, Button, message } from "antd";
import { Link, withRouter } from "react-router-dom";
import "../../scss/auth.scss";
import {
  senVerificationEmailCode,
  userLogin,
} from "../../network/auth.network";
import { connect } from "react-redux";
import {
  setCurrentUser,
  setNotificationList,
} from "../../redux/user/user.action";
import localization from "../../Localization/Localization.json";
import logo from "../../assets/logo.png";
import authBG from "../../assets/auth.png";
import { requestForToken } from "../../firebase";
import { AddPushToken, GetAllNotification } from "../../network/home.network";
import PhoneInput from "react-phone-number-input";
import { isValidPhoneNumber } from "react-phone-number-input";
import { parsePhoneNumber } from "react-phone-number-input";

class Login extends Component {
  constructor() {
    super();
    this.state = {
      btnLoading: false,
      isLoginValid: false,
    };
  }

  handelAddNotification = async () => {
    const userToken = await requestForToken();
    let body = {
      Token: userToken,
      OS: "WEB",
    };
    console.log(userToken);
    AddPushToken(
      body,
      (res) => {
        // console.log(res)
        GetAllNotification(
          (res) => {
            this.props.dispatch(setNotificationList(res?.data?.model));
            // audioTune.play();
          },
          (err) => {}
        );
      },
      (err) => {
        console.log(err);
      }
    );
  };
  onFinish = (values) => {
    this.setState({ btnLoading: true });
    let body = {
      PhoneKey: "+" + parsePhoneNumber(values?.PhoneNumber)?.countryCallingCode,
      PhoneNumber: parsePhoneNumber(values?.PhoneNumber)?.nationalNumber,
      Password: values.password,
    };

    userLogin(
      body,
      (res) => {
        let data = res?.data?.model;
        this.setState({ btnLoading: false });
        localStorage.setItem("tokenCi", data?.Token?.access_token);
        localStorage.setItem(
          "isAuthenticatedCi",
          data?.Token?.access_token && true
        );
        //localStorage.setItem("role",localStorage.getItem("lang")==="ar"? data?.EmployeeType.NameLT: data?.EmployeeType.Name)
        this.props.dispatch(setCurrentUser({ ...res?.data?.model }));
        this.handelAddNotification();
        setTimeout(() => {
          this.props.history.replace("/orders");
        }, 500);
      },
      (error) => {
        if (error.Code === 34 || error.Code === 9) {
          message.warn("سيتم ارسال كود التأكيد الى بريدك الالكتروني");
          this.props.history.push({
            pathname: "/phone-verification",
            state: {
              PhoneKey:
                "+" + parsePhoneNumber(values?.PhoneNumber)?.countryCallingCode,
              PhoneNumber: parsePhoneNumber(values?.PhoneNumber)
                ?.nationalNumber,
              email: body.Email,
              status: 1,
            },
          });
          // senVerificationEmailCode(
          //   body.Email,
          //   (res) => {
          //     this.props.history.push({
          //       pathname: "/phone-verification",
          //       state: { email: body.Email, status: 1 },
          //     });
          //   },
          //   (err) => {
          //     message.error("من فضلك حاول مرة أخرى");
          //   }
          // );
        } else message.error("تأكد من صحة البريد الإلكترونى أو كلمة المرور");
        this.setState({ btnLoading: false });
      }
    );
  };

  render() {
    const { btnLoading, isLoginValid } = this.state;
    const { currentLang } = this.props;
    return (
      <div className="auth-wrapper page-wrapper-no-header">
        <img src={authBG} className="auth-bg" alt="" />
        <div className="auth-form-content">
          <Link to="/home" className="logo-holder">
            <img src={logo} alt="logo" />
          </Link>
          <p className="form-welcom">
            {/* {localization.Welcome[currentLang]} */}
          </p>
          {/* <p className="login-text">{localization.Loginaccount[currentLang]}</p> */}
          {/* <p className="user-text">{localization.NewUser[currentLang]}<Link to="/register">{localization.Createaccount[currentLang]}</Link> </p> */}
          <Form name="basic" onFinish={this.onFinish}>
            {/* <Form.Item
              label={localization.EmailAddress[currentLang]}
              name="username"
              rules={[
                {
                  required: true,
                  message: `${localization.pleaseInput[currentLang]} ${localization.EmailAddress[currentLang]}`,
                },
              ]}
              className="input-holder"
            >
              <Input />
            </Form.Item> */}

            <Form.Item
              label="رقم الجوال"
              name="PhoneNumber"
              className="input-holder"
              rules={[
                {
                  validator(_, value) {
                    let phoneValid = isValidPhoneNumber(value || "");
                    if (!value)
                      return Promise.reject("من فضلك ادخل رقم الجوال");
                    else if (!phoneValid)
                      return Promise.reject("رقم الجوال غير صحيح");
                    else return Promise.resolve();
                  },
                },
              ]}
            >
              <PhoneInput
                international
                countryCallingCodeEditable={false}
                defaultCountry="SA"
                // value={this.state.numberVal}
                // onChange={(val) => this.setState({ numberVal: val })}
              />
            </Form.Item>

            <Form.Item
              label={localization.Password[currentLang]}
              name="password"
              className="input-holder"
              rules={[
                {
                  required: true,
                  message: `${localization.pleaseInput[currentLang]} ${localization.Password[currentLang]}`,
                },
              ]}
            >
              <Input.Password />
            </Form.Item>
            <Button
              size="large"
              type="primary"
              htmlType="submit"
              block
              loading={btnLoading}
            >
              {localization.Signin[currentLang]}
            </Button>
            <p className="create-user-holder">
              مستخدم جديد ؟
              <Link className="forget-link" to="/signup">
                إنشاء حساب
              </Link>{" "}
            </p>
            <Link className="forget-link" to="/forget-password">
              {localization.Forgetpassword[currentLang]}
            </Link>
          </Form>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  currentLang: state.user.currentLang,
});

const LoginWithRouter = withRouter(Login);
export default connect(mapStateToProps)(LoginWithRouter);
